import React from 'react';
import { Accordion } from 'react-bootstrap-accordion';
import { useState } from 'react';
import PageTitle from '../components/pagetitle';
import { useEffect } from 'react';
import { getAddress } from '../helpers/get-address';

function Contracts() {
  const [ethereumContracts, setEthereumContracts] = useState({});
  const [avalancheContracts, setAvalancheContracts] = useState({});
  const [binanceContracts, setBinanceContracts] = useState({});
  const [baseContracts, setBaseContracts] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const contracts1 = getAddress(1);
    const contracts2 = getAddress(43114);
    const contracts3 = getAddress(56);
    const contracts4 = getAddress(8453);
    setEthereumContracts(contracts1);
    setAvalancheContracts(contracts2);
    setBinanceContracts(contracts3);
    setBaseContracts(contracts4)
    // setTimeout(() => {
    //     setIsOpen(true)
    // }, 200);
  });
  return (
    <div>
      {/* <PageTitle heading="" title="Contracts" /> */}

      <section className="faq">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="block-text center">
                <h4 className="heading" style={{ color: "#119f24" }}> Smart Contracts</h4>
              </div>
            </div>
            <div className="col-md-12">
              <div className="flat-accordion">




                <div style={{ marginBottom: 30 }}>
                  <Accordion title={'Base '} show={isOpen} >
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Token:{' '}
                      {/* <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`https://basescan.org/address/${baseContracts.hope_address}`}
                        >
                          {baseContracts.hope_address}
                        </a> */}
                      <a
                        rel="noopener noreferrer"
                        href={`#`}
                      >
                       Not Launched Yet
                      </a>
                    </p>
                 
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Distributor:{' '}
                      <a
                        rel="noopener noreferrer"
                        href={`#`}
                      >
                       Not Launched Yet
                      </a>
                      {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://basescan.org/address/${baseContracts.hope_distributor}#code`}
                      >
                        {baseContracts.hope_distributor}
                      </a> */}
                    </p>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Staking:{' '}
                      {/* <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://basescan.org/address/${baseContracts.stake_address}#code`}
                      >
                        {baseContracts.stake_address}
                      </a> */}
                       <a
                        rel="noopener noreferrer"
                        href={`#`}
                      >
                       Not Launched Yet
                      </a>
                    </p>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Exchange:{' '} 
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://basescan.org/address/${baseContracts.token_exchange_address}#code`}
                      >
                        {baseContracts.token_exchange_address}
                      </a>
                    </p>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      Dumpster Submission:{' '} 
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://basescan.org/address/${baseContracts.dumpster_submission}#code`}
                      >
                        {baseContracts.dumpster_submission}
                      </a>
                    </p>
                    <p to="#"></p>
                  </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                  <Accordion title={'Ethereum '} show={false}>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Exchange:{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://etherscan.io/address/${ethereumContracts.token_exchange_address}#code`}
                      >
                        {ethereumContracts.token_exchange_address}
                      </a>
                    </p>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      Dumpster Submission:{' '} 
                      <a
                        target="_blank"
                        rel="noopener noreferrer" 
                        href={`https://etherscan.io/address/${ethereumContracts.dumpster_submission}#code`}
                      >
                        {ethereumContracts.dumpster_submission}
                      </a>
                    </p>
                    <p to="#"></p>
                  </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                  <Accordion title={'Avalanche'} show={false}>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Exchange:{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://snowtrace.io/address/${avalancheContracts.token_exchange_address}#code`}
                      >
                        {avalancheContracts.token_exchange_address}
                      </a>
                    </p>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      Dumpster Submission:{' '} 
                      <a
                        target="_blank"
                        rel="noopener noreferrer" 
                        href={`https://snowtrace.io/address/${avalancheContracts.dumpster_submission}#code`} 
                      >
                        {avalancheContracts.dumpster_submission}
                      </a>
                    </p>
                    <p to="#"></p>
                  </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                  <Accordion title={'Binance Smart Chain'} show={false}>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      OSCAR Exchange:{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://bscscan.com/address/${binanceContracts.token_exchange_address}#code`}
                      >
                        {binanceContracts.token_exchange_address}
                      </a>
                    </p>
                    <p
                      className="toggle-content"
                      style={{ fontWeight: 'bold' }}
                    >
                      {' '}
                      Dumpster Submission:{' '} 
                      <a
                        target="_blank"
                        rel="noopener noreferrer"  
                        href={`https://bscscan.com/address/${binanceContracts.dumpster_submission}#code`}
                      >
                        {binanceContracts.dumpster_submission}
                      </a>
                    </p>
                    <p to="#"></p>
                  </Accordion>
                </div>
                <div style={{ marginBottom: 30 }}>
                  <Accordion title={'Solana'} show={false}>
                    <p>Solana exchange program launching soon...</p>

                  </Accordion>
                </div>



              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contracts;
